import {AppState} from '../states/app.state';
import {identity} from 'rxjs';
import {createSelector} from '@ngrx/store';


export class SendenDialogSelectors {

  private static select = {
    state: (state: AppState) => state.sendenDialog,
    isOpen: (state: AppState) => state.sendenDialog.isOpen,
    vorschauBetreff: (state: AppState) => state.sendenDialog.vorschauBetreff,
    vorschauBody: (state: AppState) => state.sendenDialog.vorschauBody,
    vorschauLoading: (state: AppState) => state.sendenDialog.vorschauLoading,
    vorschauError: (state: AppState) => state.sendenDialog.vorschauError,
    sending: (state: AppState) => state.sendenDialog.sending,
  };

  public static isSendenDialogOpen = createSelector(
    this.select.isOpen,
    identity,
  );

  public static sendenDialogData = createSelector(
    this.select.state,
    state => ({
      betriebId: state.betriebId,
      belegId: state.belegId,
      belegnummer: state.belegnummer,
      belegart: state.belegart,
      empfaengerEmail: state.empfaengerEmail,
    }),
  );

  public static vorschauBetreff = createSelector(
    this.select.vorschauBetreff,
    identity,
  );

  public static vorschauBody = createSelector(
    this.select.vorschauBody,
    identity,
  );

  public static vorschauLoading = createSelector(
    this.select.vorschauLoading,
    identity,
  );

  public static vorschauError = createSelector(
    this.select.vorschauError,
    identity,
  );

  public static hasVorschauError = createSelector(
    this.select.vorschauError,
    e => e !== null,
  );

  public static sending = createSelector(
    this.select.sending,
    identity,
  );
}
